module.exports = __webpack_public_path__ + "img/avatar7.e864cb03.png";